import { gql } from '@apollo/client';

export const fetchSnippetUsers = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query GetSnippetUsers {
    users {
      ...userInfo
    }
  }
`;

export const fetchSnippetByName = gql`
  query FetchSnippetByName($name: String!) {
    fetchSnippetByName(name: $name) {
      content
      description
      id
      name
      positionalParameters
      __typename
    }
  }
`;
